import { useEffect, useState } from "react";
import FeatherIcon from "feather-icons-react";
import moment from "moment";
import Table from "../../../Components/UI/Table/Table";
import {
  Button,
  Col,
  Form,
  Row,
  Modal,
  Card,
} from "react-bootstrap";

import Select from "react-select";
import {
  getAllCampaigns,
  deleteCampagin,
  pauseCampaign,
  resumeCampaign,
  updateCampaign
} from "../../../Redux/Actions/CampaignsActions";

import style from "../style.module.css";
import { IReduxState } from "../../../utils/types";
import { useSelector } from "react-redux";
import { convertUtcToLocal } from "../../../utils/functions";
import { counties_list, os_list, browsers_list } from "../../Admin/AdminConstant";
import EditCampaign from "./EditCampaign";


interface cJSCListingProps {
  isAdmin: boolean;
  dispatch: any;
  listingFilterCJSCID: any;
  isDisplayCjscIdDropdown: boolean;
  defaultValueCjscID: any;
  showAll: boolean;
  isEditPopUp: boolean;
  setIsEditPopUp: (value: boolean) => void;
  setEditModalData?: any;
}

const CJSCListing = ({
  isAdmin,
  dispatch,
  listingFilterCJSCID,
  isDisplayCjscIdDropdown,
  defaultValueCjscID,
  showAll,
  isEditPopUp,
  setIsEditPopUp,
  setEditModalData,
}: cJSCListingProps) => {
  const AuthState = useSelector((state: IReduxState) => state.Auth);
  const [viewModalCountiesDD, setViewModalCountiesDD] = useState<any>([]);
  const [viewModalBrowsersDD, setViewModalBrowsersDD] = useState<any>([]);
  //const [actionCampaign, setActionCampaign] = useState<boolean>(false);
  const [viewModalOSDD, setViewModalOSDD] = useState<any>([]);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [pauseSuccess, setPauseSuccess] = useState(false);
  const [modalData, setModalData] = useState({
    cjscId: "", IP: "", orig: "", cjscName: "", endDate: "", userID: "", value: "", ua: "", ad_url: "", date: "",restrictionType:"",restrictedIds:[],
    manualScript: false, startDate: "", domains: [], domainType: "", bundles: [], bundleType: "", type: "", status: true,
    repeat: "", fakeUrl: false, panda: false, monitor: false, countries_whitelist_blacklist: "", cjsc_countries: [],ignoreHttp:false,
    oss_whitelist_blacklist: "", cjsc_os: [], urlUserAgent: false, cbl_str: "", bbl_str: "", browsers_whitelist_blacklist: "", cjsc_browsers: [], osbl_str: "", system_countries_bl: [], system_browsers_bl: [], system_oss_bl: [], sha1value: '', jsonData: '', v2_time:'', v2_ip:'', v2_ua:'', ignorHttps: false,
  });
  const CjsConfigState = useSelector((state: IReduxState) => state.Campaigns);

  let columns;

  const [isShowModal, setIsShowModal] = useState(false);

  const modalDataCountries: string[] = modalData.cjsc_countries;
  var filteredList: any[] = []

  if (modalDataCountries && modalDataCountries.length >= 0) {
    filteredList = counties_list.filter(country => modalDataCountries.includes(country.code));
    //setListCountries(filteredList)
    //console.log(filteredList)
  }

  // const modalDataRestricted:string[]=modalData.restrictedIds;
  // var restrictedArr: any[] = []
  // if(modalDataRestricted&&modalDataRestricted.length>=0){
  //   console.log(modalDataRestricted);
  //   restrictedArr = modalDataRestricted.map(item=>item.replace(",","\n"));
  // }

  const modalDataBrowsers: string[] = modalData.cjsc_browsers;
  var filteredBrowsersList: any[] = []
  if (modalDataBrowsers && modalDataBrowsers.length >= 0) {
    filteredBrowsersList = browsers_list.filter(browser => modalDataCountries.includes(browser.name));
  }


  const modalDataOss: string[] = modalData.cjsc_os;
  var filteredOSList: any[] = []
  if (modalDataOss && modalDataOss.length >= 0) {
    filteredOSList = os_list.filter(os => modalDataOss.includes(os.code));
  }


  const sizePerPageList = [
    {
      text: "10",
      value: 10,
    },
    {
      text: "20",
      value: 20,
    },
    {
      text: "50",
      value: 50,
    },
    {
      text: "100",
      value: 100,
    },
  ];


  const handleDelete = async (id: any, name: string) => {
    let value;
    if (
      window.confirm(`Are you sure you would like to delete ${name}'s campaign`)
    ) {
      value = name;
      await dispatch(deleteCampagin(value));
    }
    setDeleteSuccess(!deleteSuccess);
    dispatch(
      getAllCampaigns(
        listingFilterCJSCID ? listingFilterCJSCID?.value : defaultValueCjscID, null
      )
    );
    setDeleteSuccess(!deleteSuccess);
  };

  const handlePause = async (id: any, name: string) => {
    let value;
    if (
      window.confirm(`Are you sure you want to pause ${name}`)
    ) {
      value = name;
      await dispatch(pauseCampaign(value));
    }
    setPauseSuccess(!pauseSuccess);
    dispatch(
      getAllCampaigns(
        listingFilterCJSCID ? listingFilterCJSCID?.value : defaultValueCjscID, null
      )
    );
    setPauseSuccess(!pauseSuccess);
  };

  const handleResume = async (id: any, name: string) => {
    let value;
    if (
      window.confirm(`Are you sure you want to resume ${name}`)
    ) {
      value = name;
      await dispatch(resumeCampaign(value));
    }
    //setPauseSuccess(!pauseSuccess);
    dispatch(
      getAllCampaigns(
        listingFilterCJSCID ? listingFilterCJSCID?.value : defaultValueCjscID, null
      )
    );
    //setPauseSuccess(!pauseSuccess);
  };

  const handleEdit = async (row: any) => {
    let value = row.cjscName;
    await dispatch(pauseCampaign(value));
    setPauseSuccess(!pauseSuccess);
    dispatch(
      getAllCampaigns(
        listingFilterCJSCID ? listingFilterCJSCID?.value : defaultValueCjscID, null
      )
    );
    setPauseSuccess(!pauseSuccess);
    
    setEditModalData(row);
    setIsEditPopUp(true);
  };

  const handleView = (row: any) => {
    let cjsc_countries = row?.cjsc_countries;
    let filteredList: any = [];
    let filteredListDD: any = [];
    if (cjsc_countries && cjsc_countries.length >= 0) {
      filteredList = counties_list.filter((country) =>
        cjsc_countries.includes(country.code)
      );
      filteredListDD = filteredList.map(
        (x: { code: string; name: string }) => {
          return { value: x.code, label: x.name };
        }
      );
    }
    setViewModalCountiesDD(filteredListDD);

    //browsers
    let cjsc_browsers = row?.cjsc_browsers;
    let filteredBrowsersList: any = [];
    let filteredListBrowsersDD: any = [];
    if (cjsc_browsers && cjsc_browsers.length >= 0) {
      filteredBrowsersList = browsers_list.filter((browser) =>
        cjsc_browsers.includes(browser.name)
      );
      filteredListBrowsersDD = filteredBrowsersList.map(
        (x: { code: string; name: string }) => {
          return { value: x.name, label: x.name };
        }
      );
    }
    setViewModalBrowsersDD(filteredListBrowsersDD);

    //os
    let cjsc_os = row?.cjsc_os;
    let filteredOSList: any = [];
    let filteredListOSDD: any = [];
    if (cjsc_os && cjsc_os.length >= 0) {
      filteredOSList = os_list.filter((os) =>
        cjsc_os.includes(os.code)
      );
      filteredListOSDD = filteredOSList.map(
        (x: { code: string; name: string }) => {
          return { value: x.code, label: x.name };
        }
      );
    }
    setViewModalOSDD(filteredListOSDD);

    // console.log(AuthState.cbl);

    //   var cbl_str ='';
    //   if(row.countries_whitelist_blacklist==='bl'){
    //     row.countriesBL=AuthState.countries;
    //     const cbl_list = counties_list.filter(country => (row.countriesBL.includes(country.code)));
    //     cbl_list.forEach(el => {
    //       cbl_str +=el.name+" ("+el.code+"), ";
    //   });
    //   row.cbl_str = cbl_str.slice(0,-2);
    // }
    var cbl_str = '';
    if (row?.system_countries_bl.length > 0) {
      row.countriesBL = row?.system_countries_bl;
      const cbl_list = counties_list.filter(country => (row.countriesBL.includes(country.code)));
      cbl_list.forEach(el => {
        cbl_str += el.name + " (" + el.code + "), ";
      });
      row.cbl_str = cbl_str.slice(0, -2);
    }
    //browsers


    var bbl_str = '';
    if (row?.system_browsers_bl.length > 0) {
      row.browsersBL = row?.system_browsers_bl;
      const bbl_list = browsers_list.filter(browser => (row.browsersBL.includes(browser.name)));
      bbl_list.forEach(el => {
        bbl_str += el.name + " (" + el.name + "), ";
      });
      row.bbl_str = bbl_str.slice(0, -2);
    }
    //oss

    var osbl_str = '';
    if (row?.system_oss_bl.length > 0) {
      row.osBL = row?.system_oss_bl;
      const oss_list = os_list.filter(os => (row.osBL.includes(os.code)));
      oss_list.forEach(el => {
        osbl_str += el.name + " (" + el.code + "), ";
      });
      row.osbl_str = osbl_str.slice(0, -2);
    }

    setModalData(row);
    setIsShowModal(true);
  }


  const checkHourGlass = (cdate: string) => {
    let now = new Date();
    let result = moment(now).diff(cdate, 'minutes')
    // console.log(result);
    return !(result >= 1)
  }



  const handleDate = (input: string) => {
    /*let dateArr = input.split("T");
        return dateArr[0];*/
    return convertUtcToLocal(input, "DD/MM/YYYY");
  };

  const handleTableDate = (startDate: string, endDate: string) => {
    /*let startTimeArr = startDate.split("T");
        let endTimeArr = endDate.split("T");

        return `${startTimeArr[0]}  -  ${endTimeArr[0]}       
        ${startTimeArr[1]} - ${endTimeArr[1]}`;*/

    let startDt = convertUtcToLocal(startDate, "DD/MM/YYYY HH:mm");
    let endDt = convertUtcToLocal(endDate, "DD/MM/YYYY HH:mm");
    return `${startDt} - ${endDt}`;
  };



  columns = [
    {
      Header: "Actions",
      accessor: "",
      width: 90,
      Cell: ({ row }: any) => (
        <Col className="d-flex justify-content-between">
          {AuthState.allow_pause && (row.original.status == undefined || row.original.status == true) && (
            <p
              onClick={() => {
                let id;
                if (row.original.userID) {
                  id = row.original.userID;
                } else if (row.original.IP) {
                  id = row.original.IP;
                }
                handlePause(id, row.original.cjscName);
              }}
            >
              <FeatherIcon icon="pause" className="icon-dual icon-mdsm" />
            </p>
          )}
          {AuthState.allow_pause && row.original.status == false && (
            <p
              onClick={() => {
                let id;
                if (row.original.userID) {
                  id = row.original.userID;
                } else if (row.original.IP) {
                  id = row.original.IP;
                }
                handleResume(id, row.original.cjscName);
              }}
            >
              <FeatherIcon icon="play" className="icon-dual icon-mdsm" />
            </p>
          )}
          <p
            onClick={() => {
              let id;
              if (row.original.userID) {
                id = row.original.userID;
              } else if (row.original.IP) {
                id = row.original.IP;
              }
              handleDelete(id, row.original.cjscName);
            }}
          >
            <FeatherIcon icon="trash-2" className="icon-dual" />
          </p>
        </Col>
      ),
    },
    {
      Header: "Status",
      accessor: "g",
      width: 80,
      Cell: ({ row }: any) => {
        return (row.original.status == undefined || row.original.status == true) ?
          (<span className="badge bg-success rounded-rectangle noti-icon-badge">
            Active
          </span>) : (<span className="badge bg-warning rounded-rectangle noti-icon-badge">
            Paused
          </span>)

      }

    },

    {
      Header: "",
      accessor: "d",
      width: 80,
      // Cell: ({ row }: any) => `${checkHourGlass(row.original.date)?'{<p><i className="bi bi-hourglass-split"></i></p>}':""}`
      Cell: ({ row }: any) => (
        checkHourGlass(row.original.date) && <p className="bi bi-hourglass-split icon-large icon-dual"></p>
      )

      //     {(&&{
      //     <p>
      //       <i className="bi bi-hourglass-split"></i>
      //     </p>
      //     })
      //     },


    },
    {
      Header: "Type",
      accessor: "type",
      width: 150,
      sort: false,
      Cell: ({ value }: any) => (value === 'Header' ? 'IP Address' : value === 'Query' ? 'User ID' : value === 'iPnoId' ? 'IP without USER ID' : value === 'FIFO' ? 'FIFO' : value === 'Both' ? 'User ID + IP Address' : value === 'multiad_ipid' ? 'Multi Ad URL With User ID' : value === 'multiad_ipnoid' ? 'Multi Ad URL Without User ID' : value === 'InfiFIFO' ? 'Infinite FIFO' : value),
    }
  ];
  if (isDisplayCjscIdDropdown) {
    columns = [
      ...columns,
      {
        Header: "ID",
        accessor: "orig",

        width: 150,
        sort: false,
      },
    ];
  }

  columns = [
    ...columns,
    {
      Header: "Name",
      accessor: "cjscName",
      width: 150,
      sort: false,
    },
    {
      Header: "Date",
      accessor: "date",
      sort: false,
      width: 150,
      Cell: ({ row }: any) => `${handleDate(row.original.date)}`,
    },
    {
      Header: "ADID",
      accessor: "userID",
      width: 150,
      sort: false,
      // Cell:({row }:any)=> `${breakline(row.original.userID)}`
      Cell: ({ row }: any) => {
        const userIdsJSX = row.original.userID?.split(",")
          .map((userId: string, idx: number) => (
            <span key={`${userId}${idx}`}>{userId}</span>
          ));
        return <div className={style.user_ids_td}>{userIdsJSX}</div>;
      },
    },
    // {
    //   Header: "Hashed ID",
    //   accessor:"sha1value",
    //   width: 150,
    //   sort: false,
    // },
    {
      Header: "IP Address",
      accessor: "IP",
      width: 150,
      sort: false,
      Cell: ({ row }: any) => {
        const ipsJSX = row.original.IP?.split(",")
          .map((IP: string, idx: number) => (
            <span key={`${IP}${idx}`}>{((IP.match(/:/g) || []).length >= 2 ? (!IP.endsWith(':') ? IP += ':X' : IP += 'X') : ((IP.match(/\./g) || []).length === 2 ? (!IP.endsWith('.') ? IP += '.X' : IP += 'X') : (IP.match(/\./g) || []).length === 3 ? (!IP.endsWith('.') ? IP : IP += 'X') : IP))}</span>
          ));
        return (
          <div className={style.user_ids_td}>
            <div className="scrollable-content">{ipsJSX}</div>
          </div>
        );
      },
    },
    {
      Header: "Time Frame",
      accessor: "startDate",
      width: 600,
      sort: false,
      Cell: ({ row }: any) =>
        `${handleTableDate(row.original.startDate, row.original.endDate)}`,
    },
    {
      Header: "View",
      accessor: "",
      width: 150,
      Cell: ({ row }: any) =>
        <div style={{ display: "flex", gap: "8px"}}>
        <p
          onClick={() => {
            let id;
            if (row.original.userID) {
              id = row.original.userID;
            } else if (row.original.IP) {
              id = row.original.IP;
            }
            handleView(row.original);
          }}
        >
          <FeatherIcon icon="eye" className="icon-dual" />
        </p>
        { AuthState.allow_edit && (
            row.original.type === "Header" ||
            row.original.type === "Query" ||
            row.original.type === "iPnoId" ||
            row.original.type === "Both"
          ) &&
        <p
          onClick={() => {
            let id;
            if (row.original.userID) {
              id = row.original.userID;
            } else if (row.original.IP) {
              id = row.original.IP;
            }
            handleEdit(row.original);
          }}
        >
          <FeatherIcon icon="edit" className="icon-dual" />
        </p>
    }
        </div>
        

    }

  ];

  useEffect(() => {
    let cjscID = listingFilterCJSCID
      ? listingFilterCJSCID?.value
      : defaultValueCjscID;
    dispatch(getAllCampaigns(cjscID, showAll));
    let syncCampaignID = setInterval(() => {
      dispatch(getAllCampaigns(cjscID, showAll));
    }, 15000);
    return () => {
      clearInterval(syncCampaignID);
    };
  }, [dispatch, listingFilterCJSCID, defaultValueCjscID, showAll]);

  // const cjsc_countries_names = {modalData.cjsc_countries.map((x: { code: string; name: string; }) => {
  //    return { value: x.code, label: x.name };
  // })}

  //const countryNames = modalData.cjsc_countries.map(country => country.)

  let ipAddresses = modalData.IP?.split(',');

  let modifiedIPs = ipAddresses?.map(ip => {
    let newIP = ip.trim();

    if ((newIP.match(/:/g) || []).length >= 2) {
      if (!newIP.endsWith(':')) {
        newIP += ':X';
      }
      else {
        newIP += 'X'
      }
    }
    //((IP.match(/\./g) || []).length == 2 ? (!IP.endsWith('.') ? IP += '.X' : IP += 'X') : (IP.match(/\./g) || []).length == 3 ? (!IP.endsWith('.') ? IP : IP += 'X') : IP)
    else if ((newIP.match(/\./g) || []).length === 2) {
      if (!newIP.endsWith('.')) {
        newIP += '.X';
      }
      else {
        newIP += 'X'
      }
    }
    else if ((newIP.match(/\./g) || []).length === 3) {
      if (newIP.endsWith('.')) {
        newIP += 'X'
      }
    }
    return newIP;
  });

  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(modalData.jsonData));
  };

  return (
    <>
     { !isEditPopUp && (
      <div className="Table-Box-Table">
        <Table
          columns={columns}
          data={CjsConfigState.campaigns}
          pageSize={10}
          sizePerPageList={sizePerPageList}
          isSortable={false}
          pagination={true}
          isSearchable={false}
        />
      </div>
    )} 

      <Modal className="modal-xl"
        show={isShowModal}
        onHide={() => {
          setIsShowModal(false);
        }}
      >
        <div style={{ overflowY: 'initial' }}>
          <div>
            <div style={{ height: '80vh', overflowY: 'auto' }}>
              <div className="form">
                <div>
                  <Row className="d-flex justify-content-center mt-3"><h3 className="module_title">Campaigns</h3></Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                        <Form.Label column lg={3} htmlFor="simpleinput" id="smallerFontSize" >Campaigns ID {<span style={{ fontFamily: 'Silka', fontSize: 12, color: '#dc3545' }} >{ }</span>}</Form.Label>
                        <Col lg={9}>

                          <Form.Control
                            readOnly
                            disabled
                            value={modalData.orig}
                            className="react-select react-select-container fsz-875rem"
                            name="origin"
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                        <Form.Label column lg={3} htmlFor="simpleinput" id="smallerFontSize">Name </Form.Label>
                        <Col lg={9}>
                          <Form.Control name="name" type="text" id="simpleinput" disabled readOnly value={modalData.cjscName}>
                          </Form.Control>
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                        <Form.Label column lg={3} id="smallerFontSize" style={{ alignSelf: "flex-start" }} >{modalData.userID !== '' ? "User IDs" : 'IP Addresses'} </Form.Label>
                        <Col lg={9}>
                          <Form.Control id="example-email" name="userID" as="textarea" rows={2} disabled readOnly value={modalData.userID?.replace(/,/gi, '\n') || (modifiedIPs?.length > 0 ? modifiedIPs?.join('\n') : modalData.IP)?.replace(/,/gi, '\n')} />
                          <Form.Control.Feedback type="invalid">  </Form.Control.Feedback>
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                        <Form.Label column lg={3} id="smallerFontSize"> URL Type </Form.Label>
                        <Col lg={9}>
                          <Form.Control
                            readOnly
                            disabled
                            value={modalData.fakeUrl ? "Test URL" : modalData.panda ? "De-anon" : modalData.manualScript ? "Script" : modalData.urlUserAgent === true ? "User Agent" : modalData.monitor ? "Monitor" : "Ad URL"}
                            className="react-select react-select-container fsz-875rem"
                            name="origin"
                          />

                        </Col>
                      </Form.Group>
                      {modalData.type === "FIFO" &&

                        <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                          <Form.Label column lg={3} id="smallerFontSize"> Max FIFO Activitions   <span style={{ color: "#dc3545", fontFamily: "Silka", fontSize: 12 }} ></span> </Form.Label>
                          <Col lg={9}>
                            <Form.Control type="number" id="maxFifo" name="maxFifo" disabled readOnly className="fsz-875rem" value={modalData.repeat} />
                            <Form.Control.Feedback type="invalid">  </Form.Control.Feedback>
                          </Col>
                        </Form.Group>

                      }


                    </Col>
                    <Col md={6}>
                      {(
                        <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                          <Form.Label column lg={3} id="smallerFontSize">&nbsp;</Form.Label>
                          <Col lg={9}></Col>
                        </Form.Group>
                      )}
                      <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                        <Form.Label column lg={3} id="smallerFontSize"> Type </Form.Label>
                        <Col lg={9}>
                          <Form.Control className="fsz-875rem" name="type" disabled value={modalData.type ? modalData.type === 'Query' ? "User ID" : modalData.type === 'Header' ? "IP Address" : modalData.type === 'Both' ? "User ID + IP Address" : modalData.type === 'iPnoId' ? "IP Without User ID" : modalData.type === "multiad_ipid" ? "Multi Ad URL With User ID" : modalData.type === "multiad_ipnoid" ? "Multi Ad URL Without User ID" :modalData.type === "FIFO" ? "FIFO":"Infinite FIFO" : ''}
                          >
                          </Form.Control>
                        </Col>
                      </Form.Group>


                      {/* <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                  <Form.Label column lg={3} id="smallerFontSize">IP Address{(<span style={{ fontFamily: 'Silka', fontSize: 12, color: '#dc3545' }}></span>)}
                  </Form.Label>
                  <Col lg={9}>
                    <Form.Control id="example-date" type="text" name="IP" disabled readOnly value={modalData.IP} className="fsz-875rem" />
                    <Form.Control.Feedback type="invalid">  </Form.Control.Feedback>
                  </Col>
                </Form.Group> */}
                      {(modalData.type === 'Header' || modalData.type === 'iPnoId') && <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                        <Form.Label column lg={3} id="smallerFontSize">User Agent</Form.Label>
                        <Col lg={9}>
                          <Form.Control id="user-agent" type="text" name="userAgent" disabled readOnly value={modalData.ua} className="fsz-875rem" />
                        </Col>
                      </Form.Group>}

                      {modalData.type === 'Both' &&
                        (<Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                          <Form.Label column lg={3} htmlFor="example-email" id="smallerFontSize" style={{ alignSelf: "flex-start" }} >{'IP Addresses'}</Form.Label>
                          <Col lg={9}>
                            <Form.Control id="example-email" name="ips" as="textarea" rows={2} disabled readOnly value={(modifiedIPs.length > 0 ? modifiedIPs.join('\n') : modalData.IP).replace(/,/gi, '\n')} />
                            <Form.Control.Feedback type="invalid">  </Form.Control.Feedback>
                          </Col>
                        </Form.Group>)}
                    </Col>
                  </Row>
                </div>
              </div>

              <Card className="mt-3">
                <Card.Body>
                  <h4 className="mb-3 header-title mt-0">Whitelists and Blacklists</h4>

                  <Row>
                    <Col md={6}>
                      <Form.Label column lg={3} id="smallerFontSize">Domains</Form.Label>
                      <Form.Group as={Row} style={{ display: "flex", alignItems: "center" }}>
                        <Col lg={9}>
                          <div className="checkboxes">
                            <Form.Check disabled type="radio" name="domains_whitelist_blacklist" value="off" checked={modalData.domains && modalData.domains.length <= 0 ? true : false}></Form.Check> <Form.Label style={{ marginLeft: "5px" }} column lg={4} id="smallerFontSize"> Off </Form.Label>
                            <Form.Check disabled type="radio" name="domains_whitelist_blacklist" value="on" checked={modalData.domains && modalData.domains.length > 0 && modalData.domainType === 'wl' ? true : false} style={{ marginLeft: "5px" }} /> <Form.Label style={{ marginLeft: "5px" }} column lg={4} id="smallerFontSize"> Whitelist </Form.Label>
                            <Form.Check disabled type="radio" name="domains_whitelist_blacklist" value="on" checked={modalData.domains && modalData.domains.length > 0 && modalData.domainType === 'bl' ? true : false} style={{ marginLeft: "5px" }} /> <Form.Label style={{ marginLeft: "5px" }} column lg={4} id="smallerFontSize"> Blacklist </Form.Label>
                            <Form.Check disabled type="radio" name="domains_whitelist_blacklist" value="on" checked={modalData.domainType === 'blk' ? true : false} style={{ marginLeft: "5px" }} /> <Form.Label style={{ marginLeft: "5px" }} column lg={6} id="smallerFontSize"> Block All Domains </Form.Label>

                          </div>
                        </Col>

                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Label column lg={3} id="smallerFontSize">Apps</Form.Label>
                      <Form.Group as={Row} style={{ display: "flex", alignItems: "center" }}>
                        <Col lg={9}>
                          <div className="checkboxes">
                            <Form.Check disabled type="radio" name="app_whitelist_blacklist" value="off" checked={modalData.bundles && modalData.bundles.length <= 0 ? true : false}></Form.Check> <Form.Label style={{ marginLeft: "5px" }} column lg={4} id="smallerFontSize"> Off </Form.Label>
                            <Form.Check disabled type="radio" name="app_whitelist_blacklist" value="on" checked={modalData.bundles && modalData.bundles.length > 0 && modalData.bundleType === 'wl' ? true : false} style={{ marginLeft: "5px" }} /> <Form.Label style={{ marginLeft: "5px" }} column lg={4} id="smallerFontSize"> Whitelist </Form.Label>
                            <Form.Check disabled type="radio" name="app_whitelist_blacklist" value="on" checked={modalData.bundles && modalData.bundles.length > 0 && modalData.bundleType === 'bl' ? true : false} style={{ marginLeft: "5px" }} /> <Form.Label style={{ marginLeft: "5px" }} column lg={4} id="smallerFontSize"> Blacklist </Form.Label>
                            <Form.Check disabled type="radio" name="app_whitelist_blacklist" value="on" checked={modalData.bundleType === 'blk' ? true : false} style={{ marginLeft: "5px" }} /> <Form.Label style={{ marginLeft: "5px" }} column lg={5} id="smallerFontSize"> Block All Apps </Form.Label>

                          </div>
                        </Col>

                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  { AuthState.show_cjsc_ignoreHttp && (
                  <Row>
                            <Col>

                                <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">Ignore http</Form.Label>
                                    <Col lg={4}>
                                    <Form.Select className="fsz-875rem" name="type" placeholder="open this select menu" disabled defaultValue={modalData.ignoreHttp?'true':'false'}>
                                                <option value={'false'}>False</option>
                                                <option value={'true'}>True</option>

                                            </Form.Select>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                  )}
                  <Row>
                    <Col>

                      <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                        <Form.Label column lg={3} id="smallerFontSize">Countries</Form.Label>
                        <Col lg={4}>
                          <Select
                            isMulti={true}
                            //   options={modalData.cjsc_countries.map((x: { code: string; name: string; }) => {
                            // return { value: x.code, label: x.name };
                            //   })}
                            className="react-select react-select-container"
                            classNamePrefix="react-select"
                            isDisabled
                            // onChange={
                            //     async (e)=>{
                            //         await setListCountries(e);
                            //         console.log(listCountries)
                            //     }
                            // }

                            // options={viewModalCountiesDD}
                            defaultValue={viewModalCountiesDD}

                          ></Select>
                        </Col>
                        <Col lg={5}>
                          <div className="checkboxes">
                            <Form.Check
                              type="radio"
                              name="countries_whitelist_blacklist"
                              checked={modalData.countries_whitelist_blacklist === 'wl'}
                              value="whitelist"
                              disabled
                              //onBlur={formik.handleBlur} 
                              style={{ marginLeft: "5px" }}
                            //onChange={(e)=>onChangeCountriesWhiteBlackList('whitelist')}
                            />
                            <Form.Label
                              style={{ marginLeft: "5px" }}
                              column
                              lg={4}
                              id="smallerFontSize"
                            >
                              Whitelist
                            </Form.Label>
                            <Form.Check
                              type="radio"
                              name="countries_whitelist_blacklist"
                              checked={modalData.countries_whitelist_blacklist === 'bl'}
                              value="blacklist"
                              disabled
                              //onBlur={formik.handleBlur} 
                              style={{ marginLeft: "5px" }}
                            //onChange={(e)=>onChangeCountriesWhiteBlackList('blacklist')}
                            />
                            <Form.Label
                              style={{ marginLeft: "5px" }}
                              column
                              lg={4}
                              id="smallerFontSize"
                            >
                              Blacklist
                            </Form.Label>
                          </div>
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  {modalData.system_countries_bl.length > 0 &&
                    <Row>
                      <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                        <Col lg={3}></Col>

                        <Col lg={4}>
                          <FeatherIcon icon="alert-circle" size={15} /><b>  System Blacklisted Countries : </b>{modalData.cbl_str}
                        </Col>
                      </Form.Group>
                    </Row>}
                  <Row>
                    <Col>

                      <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                        <Form.Label column lg={3} id="smallerFontSize">Operating Systems</Form.Label>
                        <Col lg={4}>
                          <Select
                            isMulti={true}
                            //   options={modalData.cjsc_countries.map((x: { code: string; name: string; }) => {
                            // return { value: x.code, label: x.name };
                            //   })}
                            className="react-select react-select-container"
                            classNamePrefix="react-select"
                            isDisabled
                            // onChange={
                            //     async (e)=>{
                            //         await setListCountries(e);
                            //         console.log(listCountries)
                            //     }
                            // }

                            options={viewModalOSDD}
                            defaultValue={viewModalOSDD}

                          ></Select>
                        </Col>
                        <Col lg={5}>
                          <div className="checkboxes">
                            <Form.Check
                              type="radio"
                              name="oss_whitelist_blacklist"
                              checked={modalData.oss_whitelist_blacklist === 'wl'}
                              value="whitelist"
                              disabled
                              //onBlur={formik.handleBlur} 
                              style={{ marginLeft: "5px" }}
                            //onChange={(e)=>onChangeCountriesWhiteBlackList('whitelist')}
                            />
                            <Form.Label
                              style={{ marginLeft: "5px" }}
                              column
                              lg={4}
                              id="smallerFontSize"
                            >
                              Whitelist
                            </Form.Label>
                            <Form.Check
                              type="radio"
                              name="oss_whitelist_blacklist"
                              checked={modalData.oss_whitelist_blacklist === 'bl'}
                              value="blacklist"
                              disabled
                              //onBlur={formik.handleBlur} 
                              style={{ marginLeft: "5px" }}
                            //onChange={(e)=>onChangeCountriesWhiteBlackList('blacklist')}
                            />
                            <Form.Label
                              style={{ marginLeft: "5px" }}
                              column
                              lg={4}
                              id="smallerFontSize"
                            >
                              Blacklist
                            </Form.Label>
                          </div>
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  {modalData.system_oss_bl.length > 0 &&
                    <Row>
                      <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                        <Col lg={3}></Col>

                        <Col lg={4}>
                          <FeatherIcon icon="alert-circle" size={15} /><b>  System Blacklisted OS : </b>{modalData.osbl_str}
                        </Col>
                      </Form.Group>
                    </Row>}
                    {modalData.browsers_whitelist_blacklist !== 'off' && (
                  <Row>
                    <Col>

                      <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                        <Form.Label column lg={3} id="smallerFontSize">Browsers</Form.Label>
                        <Col lg={4}>
                          <Select
                            isMulti={true}
                            //   options={modalData.cjsc_countries.map((x: { code: string; name: string; }) => {
                            // return { value: x.code, label: x.name };
                            //   })}
                            className="react-select react-select-container"
                            classNamePrefix="react-select"
                            isDisabled
                            // onChange={
                            //     async (e)=>{
                            //         await setListCountries(e);
                            //         console.log(listCountries)
                            //     }
                            // }

                            // options={viewModalBrowsersDD}
                            defaultValue={viewModalBrowsersDD}

                          ></Select>
                        </Col>
                        <Col lg={5}>
                          <div className="checkboxes">
                            <Form.Check
                              type="radio"
                              name="browsers_whitelist_blacklist"
                              checked={modalData.browsers_whitelist_blacklist === 'wl'}
                              value="whitelist"
                              disabled
                              //onBlur={formik.handleBlur} 
                              style={{ marginLeft: "5px" }}
                            //onChange={(e)=>onChangeCountriesWhiteBlackList('whitelist')}
                            />
                            <Form.Label
                              style={{ marginLeft: "5px" }}
                              column
                              lg={4}
                              id="smallerFontSize"
                            >
                              Whitelist
                            </Form.Label>
                            <Form.Check
                              type="radio"
                              name="browsers_whitelist_blacklist"
                              checked={modalData.browsers_whitelist_blacklist === 'bl'}
                              value="blacklist"
                              disabled
                              //onBlur={formik.handleBlur} 
                              style={{ marginLeft: "5px" }}
                            //onChange={(e)=>onChangeCountriesWhiteBlackList('blacklist')}
                            />
                            <Form.Label
                              style={{ marginLeft: "5px" }}
                              column
                              lg={4}
                              id="smallerFontSize"
                            >
                              Blacklist
                            </Form.Label>
                          </div>
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  )}
                  {modalData.system_browsers_bl.length > 0 && <Row>
                    <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                      <Col lg={3}></Col>

                      <Col lg={4}>
                        <FeatherIcon icon="alert-circle" size={15} /><b>  System Blacklisted Browsers : </b>{modalData.bbl_str}
                      </Col>
                    </Form.Group>
                  </Row>}
                  {modalData.type==='multiad_ipid' && (
                            <>
                                <hr />
                                    <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                        <Form.Label column lg={3} htmlFor="example-email" id="smallerFontSize" style={{ alignSelf: "flex-start" }} >
                                            User IDs
                                            <p style={{ fontWeight: 400, fontSize: "14px !important", opacity: "0.5", }}>Separated by rows</p>
                                        </Form.Label>
                                        <Col lg={4}>
                                            <Form.Control
                                                id="example-email"
                                                name="user_ids_wbl_list"
                                                value={modalData.restrictedIds.join('\n')}
                                                disabled
                                                className="fsz-875rem"
                                                as="textarea"
                                                rows={2}
                                                
                                            />
                                        </Col>
                                        <Col lg={5}>
                                        <div className="checkboxes">
                                            <Form.Check
                                                type="radio"
                                                name="user_ids_wbl_list_type"
                                                checked={modalData.restrictionType === 'wl'}
                                                value="whitelist"
                                                disabled
                                                style={{ marginLeft: "5px" }}
                                            />
                                            <Form.Label
                                                style={{ marginLeft: "5px" }}
                                                column
                                                lg={4}
                                                id="smallerFontSize"
                                                
                                            >
                                                Whitelist
                                            </Form.Label>
                                            <Form.Check
                                                type="radio"
                                                name="user_ids_wbl_list_type"
                                                checked={modalData.restrictionType === 'bl'}
                                                value="blacklist"
                                                disabled
                                                style={{ marginLeft: "5px" }}
                                            />
                                            <Form.Label
                                                style={{ marginLeft: "5px" }}
                                                column
                                                lg={4}
                                                id="smallerFontSize"
                                                
                                            >
                                                Blacklist
                                            </Form.Label>
                                        </div>
                                    </Col>
                                    </Form.Group>
                                
                            </>
                        )}
                </Card.Body>
              </Card>

              {AuthState.disrupt_opsec_v2 === true && (modalData.v2_ip || modalData.v2_time || modalData.v2_ua) && (
                <Card className="mt-3">
                    <Card.Body>
                    <h4 className="mb-3 header-title mt-0">DISRUPT AD URL OPSEC</h4>
                        <Row>
                            <Col>

                                <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">Time (In seconds)</Form.Label>
                                    <Col lg={4}>
                                        <Form.Control
                                            type="number"
                                            className="fsz-875rem"
                                            name="v2_time"
                                            value={modalData.v2_time}
                                            disabled
                                        ></Form.Control>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>

                                <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">IP Address</Form.Label>
                                    <Col lg={4}>
                                        <Form.Control
                                            type="ip"
                                            disabled
                                            value={modalData.v2_ip}
                                            className="fsz-875rem"
                                            name="v2_ip"
                                        ></Form.Control>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>

                                <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">User Agent</Form.Label>
                                    <Col lg={4}>
                                        <Form.Control
                                            type="text"
                                            value={modalData.v2_ua}
                                            className="fsz-875rem"
                                            name="v2_ua"
                                            disabled
                                        ></Form.Control>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card> )}


              <Card className="mt-1">
                <Card.Body>
                  <Row>
                    <Col md={6}>
                      <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                        <Form.Label column lg={3} id="smallerFontSize">Work Window</Form.Label>
                        {/* <Col lg={9}>
                                    <div className="checkboxes">
                                        <Form.Check disabled type="radio" name="workWindow"  value="off" defaultChecked />
                                        <Form.Label style={{ marginLeft: "5px" }} column lg={2} id="smallerFontSize"> Off </Form.Label>

                                        <Form.Check disabled type="radio" name="workWindow" value="on"  style={{ marginLeft: "5px" }} />
                                        <Form.Label style={{ marginLeft: "5px" }} column lg={2} id="smallerFontSize"> On </Form.Label>
                                    </div>
                                </Col> */}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                        <Form.Label column lg={3} id="smallerFontSize">Start Date  <span style={{ fontFamily: 'Silka', fontSize: 12, color: '#dc3545' }} ></span> {" "}</Form.Label>
                        <Col lg={9}>
                          <Form.Control id="example-date" type="date" name="startDate" value={modalData.startDate ? convertUtcToLocal(modalData.startDate, "YYYY-MM-DD HH:mm").split(" ")[0] : ""} disabled className="fsz-875rem" />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                        <Form.Label column lg={3} id="smallerFontSize">End Date <span style={{ fontFamily: 'Silka', fontSize: 12, color: '#dc3545' }} ></span>  </Form.Label>
                        <Col lg={9}>
                          <Form.Control id="example-date" type="date" name="endDate" value={modalData.endDate ? convertUtcToLocal(modalData.endDate, "YYYY-MM-DD HH:mm").split(' ')[0] : ""} disabled className="fsz-875rem" />
                        </Col>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                        <Form.Label column lg={3} id="smallerFontSize">Start Time  <span style={{ fontFamily: 'Silka', fontSize: 12, color: '#dc3545' }} ></span> </Form.Label>
                        <Col lg={9}>
                          <Form.Control id="example-time" type="time" name="startHour" className="fsz-875rem" value={modalData.startDate ? convertUtcToLocal(modalData.startDate, "YYYY-MM-DD HH:mm").split(' ')[1] : ""} disabled readOnly
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                        <Form.Label column lg={3} id="smallerFontSize"> End Time  <span style={{ fontFamily: 'Silka', fontSize: 12, color: '#dc3545' }} > </span> </Form.Label>
                        <Col lg={9}>
                          <Form.Control id="example-time" type="time" name="endHour" className="fsz-875rem" value={modalData.endDate ? convertUtcToLocal(modalData.endDate, "YYYY-MM-DD HH:mm").split(' ')[1] : ""} disabled readOnly />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              {isAdmin &&
                <Card className="mt-1">
                  <Card.Body>
                    <Row className="align-items-center">
                      <Col xs={9}>
                        <Form.Group className="mb-0 d-flex align-items-center">
                          <Form.Label column lg={3} id="smallerFontSize" className="mb-0">
                            Mongo
                          </Form.Label>
                        </Form.Group>
                      </Col>
                      <Col xs={3} className="text-end">
                        <Button variant="info" onClick={handleCopy}>
                          Copy
                        </Button>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          id="json"
                          disabled
                          readOnly
                          value={JSON.stringify(modalData.jsonData)}
                          style={{ resize: "none", fontFamily: "monospace" }}
                        />
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              }

              <Row style={{ margin: "10px" }}>
                <Col>
                  <Button style={{ marginLeft: "0", fontWeight: "700" }} variant="primary" onClick={() => {
                    setIsShowModal(false)
                  }}>
                    Close
                  </Button>
                  {/* <Button
                        variant="outline-danger"
                        onClick={() => {
                            formik.resetForm({
                                values: {
                                    name: "",
                                    isUserID: false,
                                    isIP: false,
                                    isFIFO: false,
                                    userId: "",
                                    IP: "",
                                    adUrl: "",
                                    script: "",
                                    maxFifo:"",
                                    always: true,
                                    startDate: "",
                                    startHour: "",
                                    endDate: "",
                                    endHour: "",
                                    type: AuthState.cjsc_id?"User ID":AuthState.cjsc_ip?"IP Address":AuthState.cjsc_fifo?"FIFO":"",
                                    workWindow: "",
                                    targetLogger: "",
                                    pandaUrl:"",
                                    fakeUrl: false,
                                    panda:false
                                },
                            });
                            setIsPopUp(false);
                        }}>
                        Cancel
                    </Button> */}

                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Modal >
      {/* {actionCampaign && (
                <Dialog visible={actionCampaign}>
                    <Modal.Header closeButton style={{ border: "none" }} />

                    <Modal.Body className={style.modal_body}>
                        <h3>Action Campaign</h3>
                        <p>{actionCampaign ? `Are you sure you want to pause CAMPAIGN_NAME ?`: `When the user clicks on the “START” (play) button for a campaign, a popup window should appear - “Are you sure you want to start CAMPAIGN_NAME ?`}</p>
                    </Modal.Body>

                    <Modal.Footer className={style.modal_footer}>
                        <Button size="lg" onClick={() => setActionCampaign(false)}  >Close</Button>
                    </Modal.Footer>
                </Dialog>
            )} */}

    </>
  );

}
export default CJSCListing;
